import { create } from 'zustand'

/** Long enough to sign in to the platform first; after that it's abandoned. */
const PENDING_MS = 10 * 60_000

interface ConnectState {
  /** Platform (lowercase) this tab sent off to be connected in another tab. */
  pending: string | null
  startedAt: number
  start: (platform: string) => void
  /**
   * Called when the account's connections change. True if this tab was the
   * one waiting on `platform`, so it's the one that should say so.
   */
  finish: (platform: string) => boolean
  cancel: () => void
}

/**
 * On the web, connecting a platform happens in a new tab while this one stays
 * put. This remembers that it's waiting, for the "Waiting…" button and so the
 * tab that asked is the one that announces the result.
 */
export const useConnectStore = create<ConnectState>((set, get) => ({
  pending: null,
  startedAt: 0,

  start: (platform) => set({ pending: platform.toLowerCase(), startedAt: Date.now() }),

  finish: (platform) => {
    const { pending, startedAt } = get()
    const mine = pending === platform.toLowerCase() && Date.now() - startedAt < PENDING_MS
    if (pending === platform.toLowerCase()) set({ pending: null })
    return mine
  },

  cancel: () => set({ pending: null }),
}))
